export default __webpack_public_path__ + "static/media/home-travel-agency-hotel-img02.8e4f7398.jpg";